import { FC } from "react";
import { Box } from "@mui/material";
import { Route, Routes } from "react-router-dom";
import { CounterParty } from "../tradingCounterparties/counterParty";
import { CounterPartySignOff } from "../tradingCounterparties/counterParty/signOff";
import { Broker } from "../brokers/broker";
import { BrokerSignOff } from "../brokers/broker/signOff";
import { RequireCreateMerger } from "../../auth/requireCreateMerger";
import { CompletedMergersGrid, MergersGrid } from "./mergers";
import { NewMerger } from "./newMerger";

/**
 * The Mergers tab. A merger is a counterparty or broker with isMerger set, so the detail and
 * sign-off pages are the books' own, mounted again under /mergers so the nav stays on this tab.
 * Everything that links back to them derives its path (useEntityBasePath), and they redirect to
 * the right prefix if opened under the wrong one.
 */
export const Mergers: FC = () => (
  <Box
    display="flex"
    position="absolute"
    top={0}
    right={0}
    bottom={0}
    left={0}
    padding={2}
  >
    <Routes>
      <Route
        path="counterparty/:id/signoff"
        element={<CounterPartySignOff />}
      />
      <Route path="counterparty/:id/*" element={<CounterParty />} />
      <Route path="broker/:id/signoff" element={<BrokerSignOff />} />
      <Route path="broker/:id/*" element={<Broker />} />
      <Route path="completed" element={<CompletedMergersGrid />} />
      <Route path="/*" element={<MergersGrid />} />
    </Routes>
    <Routes>
      <Route
        path="new"
        element={
          <RequireCreateMerger>
            <NewMerger />
          </RequireCreateMerger>
        }
      />
    </Routes>
  </Box>
);
